// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
export interface IRemoteWebsiteApi
{
  onClientOperationAborted(clientOperationID: string): void;
  onClientOperationCompleted(clientOperationID: string): void;
  onClientOperationFailed(clientOperationID: string): void;
  onClientOperationUpdated(clientOperationID: string): void;
  onNativeMessagingHostRestarted(): void;
  onWebExtensionRestarted(): void;
};